import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  constructor(private router: Router) {}

  goToLogin() {
    if (this.router.url !== '/auth') {
      this.router.navigate(['/auth'], { replaceUrl: true });
    }
  }

  goToMain() {
    if (this.router.url !== '/main') {
      this.router.navigate(['/main'], { replaceUrl: true });
    }
  }

  goToDefault() {
    if (this.router.url !== '/') {
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }

  goToVerifyTfa() {
    if (this.router.url !== '/auth/verify-tfa') {
      this.router.navigate(['/auth/verify-tfa'], { replaceUrl: true });
    }
  }

  goToFarm() {
    if (this.router.url !== '/main/account') {
      this.router.navigate(['/main/account'], { replaceUrl: true });
    }
  }
}
